import { ApolloError } from '@apollo/client';

export const proxyInsufficientPrivilegesError = (err: ApolloError | undefined) => {
  const isInsufficientPrivileges = err?.graphQLErrors?.find(
    x => x?.extensions?.code === 'INSUFFICIENT_PRIVILEGES'
  );

  return isInsufficientPrivileges ? undefined : err;
};
